import { QueryClient } from '@tanstack/react-query';
import { getApiErrorStatus } from './api-error';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: unknown) => {
        const status = getApiErrorStatus(error);
        if (status !== undefined && [400, 401, 403, 404, 422].includes(status)) {
          return false;
        }
        return failureCount < 2;
      },
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
